import { getContext } from '@fiverr-private/fiverr_context';

export const formatFullDateShort = (_date: string | number | Date) => {
    if (!_date) return '';
    const { locale } = getContext();
    const date = new Date(_date);
    return date.toLocaleDateString(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};
